<mat-dialog-content>
  <h3>Confirm Micro deposit</h3>
  <p>Please confirm the <span class="bold">2 deposits</span> in the range of <span class="bold">$0.01 - $0.99</span></p>
  <p>that have arrived to your account <span class="bold">{{data.bankName}} {{data.last4}}</span></p>


  <form [formGroup]="form">
    <div class="input-control">
      <div>First deposit:</div>
      <mat-form-field class="full-width">
        <div matTextPrefix>$0.</div>
        <input matInput type="number" [formControlName]="'firstDeposit'">
        <mat-error>Expected value 1 to 99</mat-error>
      </mat-form-field>
    </div>
    
    <div class="input-control">
      <div>Second deposit:</div>
      <mat-form-field class="full-width">
        <div matTextPrefix>$0.</div>
        <input matInput type="number" [formControlName]="'secondDeposit'">
        <mat-error>Expected value 1 to 99</mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

@if(form) {
  <mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close] cdkFocusInitial [disabled]="loading">Cancel</button>
    <button mat-raised-button [disabled]="form.invalid || loading" color="primary" (click)="submit()">Submit</button>
  </mat-dialog-actions>
}